module.exports = __webpack_public_path__ + "static/media/bg3.3ef4d889.jpg";